import { render } from "./FuturesBalanceActionNumberWidgetParams.vue?vue&type=template&id=3577557a"
import script from "./FuturesBalanceActionNumberWidgetParams.vue?vue&type=script&lang=js"
export * from "./FuturesBalanceActionNumberWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script